import React from 'react';
import LazyLoad from 'react-lazyload';

const ClientLogos = () => (
  <div id="logos">
    <LazyLoad height={219} once>
      <div className="wrapper">
        <div className="logos">
          <img src="../../static/images/logos.png" alt="logos" />
          <img src="../../static/images/logos2.png" alt="logos" />
          <img src="../../static/images/logos3.png" alt="logos" />
          <img src="../../static/images/logos4.png" alt="logos" />
          <img src="../../static/images/logos5.png" alt="logos" />
          <img src="../../static/images/logos6.png" alt="logos" />
        </div>
        <div className="logos">
          <img src="../../static/images/logos7.png" alt="logos" />
          <img src="../../static/images/logos8.png" alt="logos" />
          <img src="../../static/images/logos9.png" alt="logos" />
          <img src="../../static/images/logos10.png" alt="logos" />
          <img src="../../static/images/logos11.png" alt="logos" />
          <img src="../../static/images/logos12.png" alt="logos" />
        </div>
      </div>
    </LazyLoad>
  </div>
);

export default ClientLogos;
